import React, { useState } from "react";
import './MenuCustomList.css'; 
import { useIntl } from "react-intl";
// Import the MenuOutlined icon from Ant Design
import { MenuOutlined } from "@ant-design/icons";

export function MenuCustomList({
  homeSectionRef,
  aboutSectionRef,
  rentSectionRef,
  schoolSectionRef,
  driveSectionRef,
  schoolDriveRef,
  contactSectionRef,
}) {
  const intl = useIntl();

  // Define menu items with references to their corresponding sections
  const menuItems = [
    { title: intl.formatMessage({ id: "slideTab.home" }), ref: homeSectionRef },
    { title: intl.formatMessage({ id: "slideTab.aboutUs" }), ref: aboutSectionRef },
    { title: intl.formatMessage({ id: "slideTab.drive" }), ref: rentSectionRef },
    { title: intl.formatMessage({ id: "slideTab.school" }), ref: schoolSectionRef },
    { title: intl.formatMessage({ id: "slideTab.rent" }), ref: driveSectionRef },
    { title: intl.formatMessage({ id: "slideTab.school1" }), ref: schoolDriveRef },
    { title: intl.formatMessage({ id: "slideTab.contact" }), ref: contactSectionRef },
  ];

  const [isMenuVisible, setIsMenuVisible] = useState(false);

  // Toggle the visibility of the menu
  const toggleMenuVisibility = () => {
    setIsMenuVisible((prevState) => !prevState);
  };

  // Function to scroll to the referenced section
  const goTo = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="menu-container">
      {/* Button to trigger menu visibility on click */}
      <button className="menu-button" onClick={toggleMenuVisibility}>
        {/* MenuOutlined icon */}
        <MenuOutlined style={{ fontSize: "24px" }} />
      </button>

      {/* The menu list that shows when the button is clicked */}
      {isMenuVisible && (
        <div className="menu-list">
          <ul className="menu-items">
            {menuItems.map(({ title, ref }) => (
              <li
                className="menu-item"
                key={title}
                onClick={() => goTo(ref)} // Scroll to the corresponding section
              >
                <h6>{title}</h6>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
